export default function auth({ to, next, router}) {
   /*
    sino tiene session manda al login
   */

    if (!localStorage.getItem('user') || !localStorage.getItem('user').includes('id')) return router.push({ name: 'HomeLogin' })

    /*
    valida los roles
     */
    if (
        to.meta.roles
    ) {
        const { core_role_code } = JSON.parse(localStorage.getItem('user'))
        if (to.meta.roles.includes('*') || to.meta.roles.includes(core_role_code)) return next()
    }

    /*
        lo devuelve si no cumple
     */
    return router.back()
}